// Meta (Facebook) Pixel — measures the Facebook/Instagram ads: which ad brought a visit, a
// sign-up (artist or fan), a purchase, a publication. Never sends payment data, phone numbers
// or listening.
// Pixel ID comes from REACT_APP_FB_PIXEL_ID (Render, static site): without it nothing loads at
// all and no consent banner is shown.
//
// Consent (CookieBanner.jsx): outside Africa (Europe, America… — where the law asks for it) the
// pixel only starts once the visitor clicked « Accepter ». In Africa (Gabon, the main market) it
// starts directly; the visitor can still refuse from the privacy page (Privacy.jsx ConsentChoice).
const PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
const CONSENT_KEY = "mz_ads_consent"; // "yes" | "no"
export const CONSENT_EVENT = "mz-ads-consent";

let initialized = false;

const readConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};
const inAfrica = () => {
  try { return (Intl.DateTimeFormat().resolvedOptions().timeZone || "").startsWith("Africa/"); } catch { return false; }
};

/** Whether the consent banner must be shown (a pixel is configured and nobody answered yet). */
export const needsConsent = () => !!PIXEL_ID && !readConsent() && !inAfrica();
export const pixelConfigured = () => !!PIXEL_ID;
const allowed = () => !!PIXEL_ID && (readConsent() === "yes" || (!readConsent() && inAfrica()));

export function setConsent(yes) {
  try { localStorage.setItem(CONSENT_KEY, yes ? "yes" : "no"); } catch {}
  if (yes) initFbPixel();
  else if (initialized) window.location.reload(); // a refusal after acceptance: stop it for good
}

function loadScript() {
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
}

export function initFbPixel() {
  if (initialized || !allowed()) return;
  try {
    loadScript();
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
    initialized = true;
  } catch { /* measurement is best-effort: never break the site */ }
}

const track = (...args) => {
  if (!initialized) return;
  try { window.fbq(...args); } catch {}
};

/** Sign-up — standard event + one named per role, so the ads can aim at artists OR fans. */
export function trackCompleteRegistration(role) {
  const artist = role === "artist";
  track("track", "CompleteRegistration", {
    content_name: artist ? "artist_signup" : "fan_signup",
    content_category: artist ? "artiste" : "fan",
    status: true,
  });
  track("trackCustom", artist ? "InscriptionArtiste" : "InscriptionFan");
}

/** A payment was requested (the fan chose to buy). */
export function trackInitiateCheckout(price, kind) {
  track("track", "InitiateCheckout", {
    value: Number(price) || 0, currency: "USD",
    content_category: kind === "release" ? "projet" : "chanson",
  });
}

// `eventId` (the payment's id) dedupes the event if the success page mounts twice (React
// StrictMode) or the buyer reloads the confirmation page.
export function trackPurchase(value, currency, eventId, kind) {
  track(
    "track",
    "Purchase",
    { value, currency: (currency || "usd").toUpperCase(), content_type: "product",
      content_category: kind === "release" ? "projet" : "chanson" },
    eventId ? { eventID: eventId } : undefined,
  );
}

/** An artist published a song or a whole project. */
export function trackPublish(kind) {
  track("trackCustom", kind === "release" ? "PublicationProjet" : "PublicationChanson");
}
